<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <rect width="24" height="24" rx="4" ry="4" fill="#000000" />
        <circle cx="12" cy="12" r="6" stroke="white" stroke-width="3" />
    </svg>
</template>
